var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"filters_row"},[_c('div')]),_c('div',{staticClass:"filters_devider"}),_c('PageTitle'),_c('div',{staticClass:"page-padding page-padding-all"},[_c('PaymentsChart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }